var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-secondary",class:{
		'disabled': _vm.isDisabled
	},attrs:{"href":"#","role":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }